import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { Lock, Sparkles } from 'lucide-react';
import { AppLayout } from '@/components/layout/AppLayout';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { usePremiumGate, type PremiumFeature } from '@/components/subscription/PremiumGate';
import { UpgradeModal } from '@/components/subscription/UpgradeModal';

interface PremiumPageGateProps {
  feature: PremiumFeature;
  title: string;
  description: string;
  children: ReactNode;
}

export function PremiumPageGate({
  feature,
  title,
  description,
  children,
}: PremiumPageGateProps) {
  const { allowed, upgradeOpen, setUpgradeOpen } = usePremiumGate(feature);

  if (allowed) return <>{children}</>;

  return (
    <AppLayout>
      <div className="max-w-lg mx-auto py-12">
        <Card>
          <CardHeader className="text-center">
            <div className="mx-auto mb-2 flex h-12 w-12 items-center justify-center rounded-full bg-primary/10">
              <Lock className="h-6 w-6 text-primary" />
            </div>
            <CardTitle>{title}</CardTitle>
            <CardDescription>{description}</CardDescription>
          </CardHeader>
          <CardContent className="flex flex-col gap-3">
            <Button onClick={() => setUpgradeOpen(true)} className="gap-2">
              <Sparkles className="h-4 w-4" />
              Ver planes Premium
            </Button>
            <Button variant="outline" asChild>
              <Link to="/upgrade">Comparar beneficios</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
      <UpgradeModal
        open={upgradeOpen}
        onOpenChange={setUpgradeOpen}
        featureName={title}
      />
    </AppLayout>
  );
}
